import { jsx } from "react/jsx-runtime";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { validateTidalLicense } from "../../base/index.js";
function ThumbUp(props) {
  return /* @__PURE__ */ jsx(
    ThumbUpIcon,
    {
      "data-testid": "ThumbUp",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ThumbUp",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
ThumbUp.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "ThumbUp"
};
validateTidalLicense();
export {
  ThumbUp
};
//# sourceMappingURL=ThumbUp.js.map
